import { RowData } from '@scope/scope-one-ui/core/DataTable/DataTable.d';
import { EsgEventsList } from 'modules/ESGSentiment/types/esgSentiment';

export const getTableData = (data?: EsgEventsList): RowData[] =>
  (data?.events || []).map((event) => ({
    id: `${event.eventInfo.id}`,
    data: {
      name: { name: event.eventInfo.name, sentiment: event.period.label },
      scoreOne: [
        { value: event.oneMonth, change: event.oneMonthChange },
        { value: event.threeMonth, change: event.threeMonthChange },
        { value: event.sixMonth, change: event.sixMonthChange },
        { value: event.oneYear, change: event.oneYearChange },
        { value: event.oneWeek, change: event.oneWeekChange },
      ],
      scoreTwo: [
        { value: event.threeMonth, change: event.threeMonthChange },
        { value: event.sixMonth, change: event.sixMonthChange },
        { value: event.oneYear, change: event.oneYearChange },
        { value: event.oneWeek, change: event.oneWeekChange },
        { value: event.oneMonth, change: event.oneMonthChange },
      ],
      rangeScore: {
        min: Math.round(event.minOneYear.value),
        value: event.today.value,
        max: Math.round(event.maxOneYear.value),
      },
      buzzOne: [
        { value: event.attentionBuzz.oneMonth, change: event.attentionBuzz.oneMonthChange },
        { value: event.attentionBuzz.threeMonth, change: event.attentionBuzz.threeMonthChange },
        { value: event.attentionBuzz.sixMonth, change: event.attentionBuzz.sixMonthChange },
        { value: event.attentionBuzz.oneYear, change: event.attentionBuzz.oneYearChange },
        { value: event.attentionBuzz.oneWeek, change: event.attentionBuzz.oneWeekChange },
      ],
      buzzTwo: [
        { value: event.attentionBuzz.threeMonth, change: event.attentionBuzz.threeMonthChange },
        { value: event.attentionBuzz.sixMonth, change: event.attentionBuzz.sixMonthChange },
        { value: event.attentionBuzz.oneYear, change: event.attentionBuzz.oneYearChange },
        { value: event.attentionBuzz.oneWeek, change: event.attentionBuzz.oneWeekChange },
        { value: event.attentionBuzz.oneMonth, change: event.attentionBuzz.oneMonthChange },
      ],
      mentions: event.eventInfo.mentions,
      types: { name: event.eventInfo.influence.name, sentiment: 'neutral' },
    },
  }));
